import React, { useEffect } from "react";
import "./styles.scss";
import { NewsCard, NewsGroup } from "../../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../../utils/environment";
import { getCategoryById } from "../../../CreateNewItem/CreateNewCategory/service/category.service";
import { getNewsByCategoryPage } from "../../../news/service/news.service";

const categoryId = process.env.REACT_APP_FOREIGN_NEWS;
const pageCount = process.env.REACT_APP_P_COUNT;
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  const handleChangeTag = (tag) => {
    props.setTagData(tag);
  };

  useEffect(() => {
    async function fetchPageData() {
      try {
        // console.log("REACT_APP_FOREIGN_NEWS", categoryId);
        let res = await getCategoryById(categoryId);
        // console.log(res);
        if (res?.data) {
          setMenu(res?.data);
          let response = await getNewsByCategoryPage(
            categoryId,
            pageCount,
            lan
          );
          // console.log("response getNewsByCategoryPage::", response);
          if (response?.data) {
            setNews(response?.data?.news);
          } else {
            setNews([]);
          }
        } else {
          setNews([]);
        }

        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
    setIsLoading(true);
    fetchPageData();
  }, []);

  return (
    <>
      <NewsGroup
        data={{
          titleName: menu?.name?.[lan] || "",
          linkName:
            lan === "en"
              ? "More " + menu?.name?.[lan]
              : "තවත් " + menu?.name?.[lan],
        }}
        onClickViewNews={() => {
          props.history.push("/" + categoryId);
          props.setMenuName(categoryId);
        }}
      >
        {isLoading && <NewsCard data={{ type: "loading", isBorder: true }} />}
        {!isLoading &&
          news.map((item, index) => {
            // Check if the item has updates
            const hasUpdates =
              Array.isArray(item.updates) && item.updates.length > 0;

            // If updates exist, use the latest update (or modify as needed)
            const displayItem = hasUpdates
              ? { ...item, ...item.updates[item.updates.length - 1] }
              : item;

            return (
              <React.Fragment key={index}>
                <NewsCard
                  key={index}
                  data={{ type: "small", isBorder: true, isUpdate: hasUpdates }}
                  item={displayItem}
                  onClick={() => {
                    if (displayItem?.keywords?.[lan]) {
                      props.history.push(
                        `/${displayItem?.keywords?.[lan]}/${displayItem?.news_id}`
                      );
                    } else {
                      const generatedSlug = item?.title?.[lan]
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      props.history.push(
                        `/${generatedSlug}/${displayItem?.news_id}`
                      );
                    }
                  }}
                  onChangeTag={handleChangeTag}
                />
              </React.Fragment>
            );
          })}

        {/* <NewsCard
          data={{ type: "medium", isBorder: true }}
          onClick={() => {
           //  props.history.push("/news-view");
          }}
        />
        <NewsCard
          data={{ type: "medium", isBorder: true }}
          onClick={() => {
           //  props.history.push("/news-view");
          }}
        /> */}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
